import { inject, Injectable } from "@angular/core";
import {
    selectUser,
    selectUserError,
    selectUserLoading,
} from "../selectors/user.selectors";
import { UserActions } from "../actions";
import { Store } from "@ngrx/store";

@Injectable({
    providedIn: "root",
})
export class UserFacade {
    readonly store = inject(Store);

    readonly user$ = this.store.select(selectUser);

    readonly loading$ = this.store.select(selectUserLoading);

    readonly error$ = this.store.select(selectUserError);

    loadUser(): void {
        this.store.dispatch(UserActions.loadUser());
    }

    clearUser(): void {
        this.store.dispatch(UserActions.clearUser());
    }
}
